import React from "react"
import { get, isEmpty } from "lodash"
import { BaseSelect } from "components/atoms/input/select"
import { Sort } from "utils/sort"
import { BaseTable, EmptyTable } from "components/molecules/table"
import { showSymbolDetailModal, tableColumns } from "config/table_columns"
import { Panel } from "./index"
import { APIResponse } from "redux/apis/types"
import * as Formatter from "utils/Formatter"
import { Link } from "react-router-dom"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import { IndustryNum } from "components/actions/ranking"
import { checkIsSp, open_symbol_detail } from "utils/util"
import ClassNames from "classnames"

const rankingData: Array<APIResponse.Res> = [
  {
    Rank: 1,
    Symbol: "4764",
    SymbolCode: "4764",
    Name: "サムライＪＰ",
    Exchange: 1,
    SecurityType: 1,
    NumberOfDecimals: 0,
    Price: 4780,
    ChangedRatio: 13.6318,
    ChangedPrice: 0.3449,
    PriceTime: "20180904150000",
    TradVolume: 26.1,
    TradValue: 123.2305,
    EstrangeFromTradVolume: null,
    EstrangeFromTradValue: null,
    PER: null,
    PBR: null,
    TickCount: null,
    TickUp: null,
    TickDown: null,
    MarginSellQty: null,
    MarginDiffFromLastSellQty: null,
    MarginBuyQty: null,
    MarginDiffFromLastBuyQty: null,
    MarginRatio: null,
    Average: null,
    ExchangeDivision: "東証JQG",
    IndustryType: "情報・通信業",
    Color: 16749017,
  },
  {
    Rank: 2,
    Symbol: "5401",
    SymbolCode: "5401",
    Name: "新日鐵住金",
    Exchange: 5,
    SecurityType: 1,
    NumberOfDecimals: 0,
    Price: null,
    ChangedRatio: 10.6849,
    ChangedPrice: 0.3449,
    PriceTime: null,
    TradVolume: 0,
    TradValue: 0,
    EstrangeFromTradVolume: null,
    EstrangeFromTradValue: null,
    PER: null,
    PBR: null,
    TickCount: null,
    TickUp: null,
    TickDown: null,
    MarginSellQty: null,
    MarginDiffFromLastSellQty: null,
    MarginBuyQty: null,
    MarginDiffFromLastBuyQty: null,
    MarginRatio: null,
    Average: null,
    ExchangeDivision: "福証",
    IndustryType: "",
    Color: 0,
  },
  {
    Rank: 2,
    Symbol: "5401",
    SymbolCode: "5401",
    Name: "新日鐵住金",
    Exchange: 6,
    SecurityType: 1,
    NumberOfDecimals: 0,
    Price: null,
    ChangedRatio: 10.6849,
    ChangedPrice: 0.3449,
    PriceTime: null,
    TradVolume: 0,
    TradValue: 0,
    EstrangeFromTradVolume: null,
    EstrangeFromTradValue: null,
    PER: null,
    PBR: null,
    TickCount: null,
    TickUp: null,
    TickDown: null,
    MarginSellQty: null,
    MarginDiffFromLastSellQty: null,
    MarginBuyQty: null,
    MarginDiffFromLastBuyQty: null,
    MarginRatio: null,
    Average: null,
    ExchangeDivision: "札証",
    IndustryType: "",
    Color: 0,
  },
  {
    Rank: 4,
    Symbol: "5401",
    SymbolCode: "5401",
    Name: "新日鐵住金",
    Exchange: 1,
    SecurityType: 1,
    NumberOfDecimals: 0,
    Price: 2616.5,
    ChangedRatio: 10.6746,
    ChangedPrice: 0.3449,
    PriceTime: "20180904150000",
    TradVolume: 6310.5,
    TradValue: 16374.2511,
    EstrangeFromTradVolume: null,
    EstrangeFromTradValue: null,
    PER: null,
    PBR: null,
    TickCount: null,
    TickUp: null,
    TickDown: null,
    MarginSellQty: null,
    MarginDiffFromLastSellQty: null,
    MarginBuyQty: null,
    MarginDiffFromLastBuyQty: null,
    MarginRatio: null,
    Average: null,
    ExchangeDivision: "東証非上場",
    IndustryType: "",
    Color: 0,
  },
  {
    Rank: 4,
    Symbol: "5401",
    SymbolCode: "5401",
    Name: "新日鐵住金",
    Exchange: 3,
    SecurityType: 1,
    NumberOfDecimals: 0,
    Price: null,
    ChangedRatio: 10.6746,
    ChangedPrice: 0.3449,
    PriceTime: null,
    TradVolume: 0,
    TradValue: 0,
    EstrangeFromTradVolume: null,
    EstrangeFromTradValue: null,
    PER: null,
    PBR: null,
    TickCount: null,
    TickUp: null,
    TickDown: null,
    MarginSellQty: null,
    MarginDiffFromLastSellQty: null,
    MarginBuyQty: null,
    MarginDiffFromLastBuyQty: null,
    MarginRatio: null,
    Average: null,
    ExchangeDivision: "名証",
    IndustryType: "",
    Color: 0,
  },
]

type Props = {
  title: string
  RankingData: Array<APIResponse.Res>
  delete?: Function
}

export const RankingSummary = (props: Props) => {
  return (
    <Panel title={props.title} className="panel-ranking" delete={props.delete}>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
    </Panel>
  )
}

export const MultiRanking = (props: Props) => {
  return (
    <Panel title={props.title} className="panel-ranking" delete={props.delete}>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
      <div className="list-block">
        <div className="row-filter">
          <BaseSelect option={Sort.RankingSort} />
          <BaseSelect option={Sort.RankingExchange} />
        </div>
        <div className="result-list-block">
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={tableColumns.ranking.ranking("前日比 (%)")}
            data={rankingData}
          />
        </div>
      </div>
    </Panel>
  )
}

type Option = {
  id: number | string
  name: string
  priceIncrease: number
  priceReduction: number
  volume?: number
}

type RankingDataType = {
  exchangeTypeNum: number
  priceIncreaseList: Array<object>
  priceReductionList: Array<object>
  volumeList: Array<object>
  priceIncreaseTime: string
  priceReductionTime: string
  volumeTime: string
}

//上のrankingSummaryと合体させる可能性大
type RankingSummaryPanelType = {
  title: string
  rankingData: RankingDataType
  exchangeList: Array<Option>
  changeRanking: Function
  callApi: Function
}

type rankingTableType = {
  title: string
  dataList: Array<object>
  dataListTime: string
  tableColumns: Array<object>
  link: object
}

const RankingTable = (props: rankingTableType) => {
  const isPhone = checkIsSp()
  return (
    <div className={ClassNames("list-block", { sp: isPhone })}>
      <div className="control-row filter-control-row sp">
        <div className="title-border">{props.title}</div>
        <Link className="btn btn-primary btn-shaped" to={props.link}>
          もっと見る
        </Link>
        <div className="time-col">
          {Formatter.date(props.dataListTime, "MM/DD HH:mm")}
        </div>
      </div>
      <div className="result-list-block">
        {isEmpty(props.dataList) ? (
          <EmptyTable
            className="table-list-view table-liquid-cell"
            list={props.tableColumns}
          />
        ) : (
          <BaseTable
            className="table-list-view table-liquid-cell"
            list={props.tableColumns}
            data={props.dataList}
            onClick={(data: object) => {
              if (isPhone) {
                store.dispatch(showSymbol(data))
              } else {
                open_symbol_detail(data)
              }
            }}
          />
        )}
      </div>
    </div>
  )
}

export const RankingSummaryPanel: React.FC<RankingSummaryPanelType> = props => {
  const exchangeTypeNum = get(props.rankingData, "exchangeTypeNum")
  const exchangeData = props.exchangeList[exchangeTypeNum]
  const isPhone = checkIsSp()
  const createDataList = (dataList: Array<object>) => {
    return !isPhone ? dataList : dataList.slice(0, 3)
  }
  return (
    <Panel
      title={props.title}
      className="panel-ranking"
      filter={
        <div className="control-row panel-header-filter sp">
          <BaseSelect
            option={props.exchangeList}
            value={props.rankingData.exchangeTypeNum}
            onChange={async (num: number) => {
              const currentExchangeData = props.exchangeList[num]
              await props.callApi({
                exchangeTypeNum: num,
                priceIncrease: get(currentExchangeData, "priceIncrease"),
                priceReduction: get(currentExchangeData, "priceReduction"),
                volume: get(currentExchangeData, "volume"),
                changeRanking: props.changeRanking,
              })
            }}
          />
        </div>
      }
    >
      <RankingTable
        title={"値上がり率"}
        dataList={createDataList(props.rankingData.priceIncreaseList)}
        dataListTime={props.rankingData.priceIncreaseTime}
        tableColumns={
          isPhone
            ? tableColumns.ranking.rankingSp("値上がり率")
            : tableColumns.ranking.ranking("値上がり率")
        }
        link={{
          pathname: get(exchangeData, "link"),
          state: {
            isDetails: true,
            type: get(exchangeData, "priceIncrease"),
            typeNum: 1,
            exchange: get(exchangeData, "transitionExchange"),
          },
        }}
      />
      <RankingTable
        title={"値下がり率"}
        dataList={createDataList(props.rankingData.priceReductionList)}
        dataListTime={props.rankingData.priceIncreaseTime}
        tableColumns={
          isPhone
            ? tableColumns.ranking.rankingSp("値下がり率")
            : tableColumns.ranking.ranking("値下がり率")
        }
        link={{
          pathname: get(exchangeData, "link"),
          state: {
            isDetails: true,
            type: get(exchangeData, "priceReduction"),
            typeNum: 2,
            exchange: get(exchangeData, "transitionExchange"),
          },
        }}
      />
      {exchangeTypeNum !== IndustryNum && (
        <RankingTable
          title={"出来高"}
          dataList={createDataList(props.rankingData.volumeList)}
          dataListTime={props.rankingData.volumeTime}
          tableColumns={
            isPhone
              ? tableColumns.ranking.ranking_volumeSp
              : tableColumns.ranking.ranking_volume
          }
          link={{
            pathname: get(exchangeData, "link"),
            state: {
              isDetails: true,
              type: get(exchangeData, "volume"),
              typeNum: 0,
              exchange: get(exchangeData, "transitionExchange"),
            },
          }}
        />
      )}
    </Panel>
  )
}
